import { useState, useRef } from "react"

const useTabNavigationWithKeyboard = (tabs, initialActiveIndex) => {
  const tabRef = useRef([])
  const [activeIndex, setActiveIndex] = useState(initialActiveIndex)
  const tabCount = tabs.length
  const activeTab = tabs[activeIndex]

  const changeActiveTab = (e, index) => {
    e.preventDefault()
    setActiveIndex(index)
  }

  const moveFocusToTab = (targetIndex) => {
    tabRef.current[targetIndex].focus()
  }

  const moveFocusToPreviousTab = (currentIndex) => {
    if (currentIndex === 0) {
      moveFocusToTab(tabCount - 1)
    } else {
      moveFocusToTab(currentIndex - 1)
    }
  }

  const moveFocusToNextTab = (currentIndex) => {
    if (currentIndex === tabCount - 1) {
      moveFocusToTab(0)
    } else {
      moveFocusToTab(currentIndex + 1)
    }
  }

  const handleKeyDown = (e, index) => {
    const keyActions = {
      ArrowLeft: () => moveFocusToPreviousTab(index),
      ArrowRight: () => moveFocusToNextTab(index),
      ArrowUp: () => moveFocusToPreviousTab(index),
      ArrowDown: () => moveFocusToNextTab(index),
      Home: () => moveFocusToTab(0),
      End: () => moveFocusToTab(tabCount - 1),
    }

    if (keyActions[e.key]) {
      keyActions[e.key]()
      e.preventDefault()
    }
  }

  return {
    activeIndex,
    activeTab,
    setActiveIndex,
    tabRef,
    changeActiveTab,
    handleKeyDown,
  }
}

export default useTabNavigationWithKeyboard
